import axios from 'axios';

const viaCepApi = axios.create({
  baseURL: 'https://viacep.com.br/ws',
});

export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  erro?: boolean;
}

export const viaCepService = {
  buscar: async (cep: string): Promise<ViaCepResponse> => {
    try {
      const response = await viaCepApi.get(`/${cep}/json/`);
      if (response.data.erro) {
        throw new Error('CEP não encontrado');
      }
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      throw new Error('Não foi possível buscar o CEP. Verifique o valor e tente novamente.');
    }
  },
};
